export const sceneKeys = {
  boot: 'BootScene',
  mainMenu: 'MainMenuScene',
  gameplay: 'GameplayScene',
  gameOver: 'GameOverScene',
} as const;

export const storageKeys = {
  locale: 'ftr_locale',
  soundEnabled: 'ftr_sound_enabled',
  vibrationEnabled: 'ftr_vibration_enabled',
  guestId: 'ftr_guest_id',
} as const;

export const localizationTables = {
  ui: 'ui',
} as const;
